import { render, staticRenderFns } from "./PrkBeamSyllabusesEducator.vue?vue&type=template&id=64a4c65f&scoped=true&"
import script from "./PrkBeamSyllabusesEducator.vue?vue&type=script&lang=js&"
export * from "./PrkBeamSyllabusesEducator.vue?vue&type=script&lang=js&"
import style0 from "./PrkBeamSyllabusesEducator.vue?vue&type=style&index=0&id=64a4c65f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a4c65f",
  null
  
)

export default component.exports